import LocalStorageUtil from "./localStorage";

const Permission: any = {
  "AdvanceSearch": {
    "Allow View": 1,
    "Allow Build Query":2,
    "Allow Saved Queries":3,
    "Allow Metadata Compare": 5,
    "Allow Rename": 1357, 
    "Allow Download": 4,
    "Allow DocumentPreView": 7,
    "Allow Metadata Information": 8,
    "Allow Version History": 9,
    "Allow Delete": 10,
    "Allow Send to Preflight": 1352,
    "Allow Send to Downsample": 1353,
    "Allow Send to Edelivery": 1354,
    "Allow Move to Preflight": 1355,
    "Allow Upload": 1356,
    "Allow Reject": 1358,
    "Allow Add Notes": 1359,
    "Trigger Proof Flow": 1360,
    "Allow Approve with Comments": 1361,
    "Allow Approve": 1362,
    "Allow Downstream": 1366,
    "Allow Prework": 1367,
    "Allow Proofing": 1368,
    "Allow Trigger Prod Flow": 1424,
    "Allow Move to Final Folder": 1425,
    "Allow Move to Final Folder Vis": 1426,
    "Allow Menu TriggerProdFlow": 1427,
    "Allow Reprocess To VIS": 1428,
    "Allow Reprocess Sub System": 1445
  },
"ListSearch": {
  "Allow View": 51,
  "Allow Metadata Compare": 52,
  "Allow Rename": 1396,
  "Allow Download": 54,
  "Allow DocumentPreView": 55,
  "Allow Delete": 56,
  "Allow Metadata Information": 1347,
  "Allow Version History": 1348,
  "Allow Send to Preflight": 1349,
  "Allow Send to Downsample": 1350,
  "Allow Send to Edelivery": 1351,
  "Allow Move to Preflight": 1394,
  "Allow Upload": 1395,
  "Allow Reject": 1397,
  "Allow Add Instruction File": 1398,
  "TriggerProofFlow": 1399,
  "Allow Approve with Comments": 1400,
  "Allow Approve": 1401,
  "AllowDownstream": 1402,
  "AllowPrework": 1403,
  "Allow Proofing": 1404,
  "Allow TriggerProdFlow": 1429,
  "Allow Move to Final Folder": 1430,
  "Allow Move to Final Folder Vis": 1431,
  "Allow Reprocess - To Preflight": 1432,
  "Allow Reprocess To VIS": 1433,
  "Allow Reprocess Sub System": 1447
},
"Search": {
  "Allow View": 801,
  "Allow Metadata Information": 802,
  "Allow Version History": 803,
  "Allow Delete": 804,
  "Allow Download": 805,
  "Allow DocumentPreView": 806,
  "Allow Send to Preflight": 1363,
  "Allow Send to Downsample": 1364,
  "Allow Send to Edelivery": 1365,
  "Allow Move to Preflight": 1405,
  "Allow Upload": 1406,
  "Allow Rename": 1407,
  "Allow Reject": 1408,
  "Allow Add Instruction File": 1409,
  "Allow Menu TriggerProofFlow": 1410,
  "Allow Approve with Comments": 1411,
  "Allow Approve": 1412,
  "AllowDownstream": 1413,
  "AllowPrework": 1414,
  "Allow Proofing": 1415,
  "Allow Menu TriggerProdFlow": 1434,
  "Allow Move to Final Folder": 1435,
  "Allow Move to Final Folder Vis": 1436,
  "Allow Reprocess - To Preflight": 1437,
  "Allow Reprocess To VIS": 1438,
  "Allow Reprocess Sub System": 1446
},
"PreworkSummary": {
  "Allow View": 101,
  "Allow Upload": 102,
  "Allow Export to Excel": 104,
  "Allow Download": 105,
  "Allow Menu-InProgress": 106,
  "Allow Menu-Completed": 107,
  "Allow Menu-All": 108,
  "Allow DocumentPreView": 109
},
"ArchivalReport": {
  "Allow View": 351,
  "Allow Export to Excel": 352,
  "Allow Request For Archival": 353,
  "Allow Approved For Archival": 354,
  "Allow Delayed": 355,
  "Allow Not Required": 356,
  "Allow Completed": 357,
  "Allow Request For Deleting": 358,
  "Allow Approved For Delete": 359,
  "Allow Metadata Information": 1441,
  "Allow Version History": 1442
},
"PreworkDetail": {
  "Allow View": 151,
  "Allow Accept": 152,
  "Allow Export to Excel": 153,
  "Allow Download": 154,
  "Allow Move to Preflight": 155,
  "Allow Move to Final Folder": 156,
  "Allow Upload": 160,
  "Allow Rename": 157,
  "Allow Reject": 158,
  "Allow Add Instruction File": 159,
  "Allow Staging": 161,
  "Allow To preflight": 162,
  "Allow From preflight": 163,
  "Allow Consolidate": 164,
  "Allow DocumentPreView": 165,
  "Allow Delete": 167,
  "Allow From Met": 168,
  "Allow Menu-Final": 170,
  "Allow Menu-All": 171,
  "Allow Reprocess To Preflight": 172,
  "Allow Approve and Send": 173,
  "Allow Upload with Metadata Fields": 174,
  "Allow Save and Accept": 175,
  "Allow Menu From Vis": 1326,
  "Allow Menu To Vis": 1327,
  "Trigger Proof Flow": 1328,
  "Trigger Prod Flow": 1329,
  "Allow Move to Final Folder Vis": 1330,
  "Allow Add Notes Email": 176,
  "Allow Metadata Information": 166,
  "Allow Version History": 1345
},
"Downstream": {
  "Allow View": 201,
  "Allow Upload": 202,
  "Allow Accept": 203,
  "Allow Export to Excel": 204,
  "Allow Download": 205,
  "Allow Delete": 206,
  "Allow Metadata Information": 207,
  "Allow Version History": 208,
  "Allow Send to Preflight": 209,
  "Allow Send to Downsample": 210,
  "Allow Send to Edelivery": 211,
  "Allow DocumentPreView": 212,
  "Allow Return status": 213,
  "Allow Downstream Inprogress": 1344,
  "Allow Email Document": 1370,
  "Allow Reprocess Sub System": 1443,
  "Allow Asset History": 1454,
  "Allow DD Exceptions": 1444
},
"Documents": {
  "Allow View": 251,
  "Allow Download": 252,
  "Allow Version History": 253,
  "Allow Delete": 254,
  "Allow Metadata Information": 255,
  "Allow Custom Upload": 256,
  "Allow DocumentPreView": 257
},
"Filelocation": {
  "Allow View": 401,
  "Allow Create New": 402,
  "Allow Edit": 403,
  "Allow Download": 1374,
  "Allow Upload": 1375
},
"Email": {
  "Allow View": 451,
  "Allow Create New": 452,
  "Allow Edit": 453,
  "Allow Download Template": 1372,
  "Allow Upload Template": 1373
},
"Group": {
  "Allow View": 551,
  "Allow Create New": 552,
  "Allow Export to Excel": 553,
  "Allow Edit": 554,
  "Allow Duplicate": 555
},
"Users": {
  "Allow View": 501,
  "Allow Create New": 502,
  "Allow Export to Excel": 503,
  "Allow Edit": 504,
  "Allow Duplicate": 505
},
"Roles": {
  "Allow View": 601,
  "Allow Create New": 602,
  "Allow Export to Excel": 603,
  "Allow Edit": 604,
  "Allow Duplicate": 605
},
"Statistics": {
  "Allow View": 651,
  "Allow Grid View": 652,
  "Allow Grid Export to Excel": 653
},
"DashBoard": {
  "Allow PreFlight": 752,
  "Allow Final": 753,
  "Allow_PrintDelivery": 754,
  "Allow Print": 754,
  "Allow_eDelivery": 755,
  "Allow Fullview": 756,
  "Allow DSA": 757
},
"PerformanceReport": {
  "Allow View": 301,
  "Allow Export to Excel": 302,
  "Allow Downsample": 303,
  "Allow Print": 304,
  "Allow Prework": 305,
  "Allow Print Edelivery": 306,
  "Allow Web Edelivery": 307,
  "Allow Scheduler": 308
},
"MetaDataMapping": {
  "Allow View": 710,
  "Allow Create New": 711,
  "Allow Export to Excel": 712,
  "Allow Edit": 713
},
"MetaDataItem": {
  "Allow View": 715,
  "Allow Create New": 716,
  "Allow Export to Excel": 717,
  "Allow Edit": 718
},
"MetaDataGroup": {
  "Allow View": 720,
  "Allow Create New": 721,
  "Allow Export to Excel": 722,
  "Allow Edit": 723
},
"SubSystem": {
  "Allow View": 1319
},
"Source": {
  "Allow Source Config View": 1318
},
"RequesterEmail": {
  "Allow View": 1314,
  "Allow Create New": 1390,
  "Allow Edit": 1391,
  "Allow Down Load": 1392,
  "Allow Upload": 1393
},
"RequesterFileLocation": {
  "Allow View": 1316,
  "Allow Create New": 1385,
  "Allow Edit": 1386,
  "Allow Down Load": 1387,
  "Allow Upload": 1389
},
"Proofing": {
  "Allow View": 1325,
  "Allow Approve with Comments": 1331,
  "Allow Accept": 1332,
  "Allow Delete": 1333,
  "Allow Completed": 1334,
  "Allow From Source": 1335,
  "Allow Inprogress": 1336,
  "Allow Export to Excel": 1337,
  "Allow Reject": 1338,
  "Allow Upload": 1339,
  "Allow Download": 1341,
  "Allow Approve": 1342,
  "Allow Doc View": 1343,
  "Allow Metadata Information": 1340,
  "Allow Version History": 1346
},
"MetaDataDefinition": {
  "Allow View": 730,
  "Allow Create New": 731,
  "Allow Export to Excel": 732,
  "Allow Edit": 733
},
"UserPreferences": {
  "Allow View Column Header": 1376,
  "Allow View Metadata Fields": 1377
},
"ActivityReport": {
  "Allow Activity Summary": 1378,
  "Allow Activity Detail": 1379,
  "Allow Expert Excel": 1380,
  "Allow Export to Excel": 1381,
  "Allow Scheduler View": 1388
},
"ProcessStage": {
  "Allow View": 1416,
  "Allow Expert Excel": 1417,
  "Allow Edit": 1418,
  "Allow Create New": 1419
},
"Menu": {
  "Allow View": 1420,
  "Allow Expert Excel": 1421,
  "Allow Edit": 1422,
  "Allow Create New": 1423
},
"BannerMessage": {
  "Allow View": 1440
},
"DDExceptions": {
  "Allow DD Exceptions": 1444
},
"HeartBeat": {
  "Allow View": 1450
},
"RequestInformation": {
  "Allow View": 1451
},
"UserActivity": {
  "Allow View": 1452,
  "Allow Expert Excel": 1453
},
"ElasticSearch": {
  "Allow View": 1456
},
"UnMatchedAssets": {
  "Allow View": 1457,
  "Allow Expert Excel": 1458
}
};

const isPagePermission = (
  permissionName: any,
  pageName: any = "",
  permissionId: any = ""
) => {
  const isSuperAdmin = LocalStorageUtil.getItem("isSuperAdmin");
  
  if (isSuperAdmin === "1") {
    return true; 
  }

  
  console.log("autorizationData", LocalStorageUtil.getItem("authorizationData"));

if(LocalStorageUtil.getItem("authorizationData")){  const storedPermissionsString = JSON.parse(JSON.parse(LocalStorageUtil?.getItem("authorizationData") as string)?.pageControlPermission);
  if (!storedPermissionsString) return false;
  let storedPermissions = storedPermissionsString;
  const found = storedPermissions.some(
    (perm: any) =>
      perm.PermissionId === permissionId
  );
  return found;}
  return false;
};

export default isPagePermission;
